















import Vue from 'vue'
import { availableSizeOptions } from '@/types/button-style-options'

const availableTypeOptions = ['flat', 'transparent', 'rounded', 'outline']

const availableColorOptions = [
  'grey',
  'algae-green',
  'bluey-purple',
  'bluish-grey',
  'dark-teal',
  'darkish-pink',
  'dodger-blue',
  'duck-egg-blue',
  'light-orange',
  'light-peach',
  'orange',
  'reddish-orange',
  'strawberry',
  'very-light-purple',
  'viridian',
]

export default Vue.extend({
  name: 'Chicklet',

  props: {
    type: {
      type: String,
      default: 'flat',
      validator: (value: string) => {
        return availableTypeOptions.includes(value)
      },
    },

    color: {
      type: String,
      default: 'grey',
      validator: (value: string) => {
        return availableColorOptions.includes(value)
      },
    },

    size: {
      type: String,
      default: 'medium',
      validator: (value: string) => {
        return availableSizeOptions.includes(value)
      },
    },

    isUppercase: {
      type: Boolean,
      default: false,
    },

    isDisabled: {
      type: Boolean,
      default: false,
    },

    maxWidth: {
      type: String,
      default: null,
    },

    title: {
      type: String,
      default: null,
    },
  },

  computed: {
    colorClass(): string {
      const colorType = ['flat', 'rounded'].includes(this.type)
        ? 'flat'
        : this.type
      return `bg-${this.color}-${colorType}`
    },

    chickletClasses(): any {
      const baseSelector = 'chicklet'

      return {
        [this.colorClass]: true,
        [`${baseSelector}--${this.type}`]: true,
        [`${baseSelector}--${this.size}`]: true,
        [`${this.colorClass}--not-hover`]: true,
        [`${baseSelector}--uppercase`]: this.isUppercase,
        [`${baseSelector}--disabled`]: this.isDisabled,
      }
    },
  },
})
